import { AxiosClient } from "@/app/shared/services";
import { toFormData } from "@/app/shared/services/helpers";
import moment from 'moment';

const state = {
    offers: {
        data: [],
        isLoading: false,
        isSuccess: false,
    },
    tags: [],
    currentOffer: {
        name: "",
        img_path: "",
        img: null,
        url_template: "",
        description: "",
        days: "",
        bet: "",
        success_rate: "",
        sum: "",
        rate: "",
        show: false,
        use_aff_sub_params: true,
        is_money_from_approve: true,
        extra: {},
        patterns: [{ pattern: "", weight: 100 }],
        tag_sub: "",
        currency: "",
        payout: "",
        leadgid_id: "",
    },
    filters: {
        registerDate: { from: moment().format("YYYY-MM-DD"), to: moment().add(1, 'days').format("YYYY-MM-DD") },
        utmSources: [],
        type: [],
        show: 'true',
    },
    session: "",
    offerStatistics: {
        data: {
            "items": [],
            "headers": [],
        },
        isLoading: false,
        isSuccess: false,
    },
    utmSources: {
        data: [],
        isLoading: false,
        isSuccess: false,
    }
};

const getters = {
    OFFERS_IS_LOADING: (state) => state.offers.isLoading,
    OFFERS_LOADING_SUCCESS: (state) => state.offers.isSuccess,
    CURRENT_OFFER: (state) => state.currentOffer,
    OFFERS: (state) => state.offers.data,
    SUNFINANCE_TAGS: (state) => state.tags,
    STATISTICS: (state) => state.offerStatistics.data,
    UTM_SOURCES: (state) => state.utmSources.data,
    STATISTICS_IS_LOADING: (state) => state.offerStatistics.isLoading,
    STATISTICS_LOADING_SUCCESS: (state) => state.offerStatistics.isSuccess,
    UTM_SOURCES_IS_LOADING: (state) => state.utmSources.isLoading,
    UTM_SOURCES_LOADING_SUCCESS: (state) => state.utmSources.isSuccess,
    GET_OFFER_FILTERS: (state) => state.filters,
};

const mutations = {
    SET_OFFERS: (state, offers) => {
        state.offers.data = offers;
    },
    SET_OFFERS_LOADING: (state, isLoading) => {
        state.offers.isLoading = isLoading;
    },
    SET_OFFERS_LOADING_SUCCESS: (state, isSuccess) => {
        state.offers.isSuccess = isSuccess;
    },
    SET_CURRENT_OFFER: (state, offer) => {
        state.currentOffer = offer;
    },
    CHANGE_SHOW: (state, offer) => {
        offer.show = !offer.show;
    },
    SET_SUNFINANCE_TAGS: (state, tags) => {
        state.tags = tags
    },
    SET_STATISTICS: (state, statistics) => {
        state.offerStatistics.data = statistics;
    },
    SET_STATISTICS_LOADING: (state, isLoading) => {
        state.offerStatistics.isLoading = isLoading;
    },
    SET_STATISTICS_LOADING_SUCCESS: (state, isSuccess) => {
        state.offerStatistics.isSuccess = isSuccess;
    },
    SET_UTM_SOURCES: (state, utmSources) => {
        state.utmSources.data = utmSources;
    },
    SET_UTM_SOURCES_LOADING: (state, isLoading) => {
        state.utmSources.isLoading = isLoading;
    },
    SET_UTM_SOURCES_LOADING_SUCCESS: (state, isSuccess) => {
        state.utmSources.isSuccess = isSuccess;
    },
    REFRESH_OFFER_FILTERS: (state) => {
        for (const key in state.filters) {
            if (state.filters[key] instanceof Array) {
                state.filters[key] = [];
                continue;
            }
            if (state.filters[key] instanceof Object) {
                state.filters[key] = {};
                continue;
            }
            if (typeof state.filters[key] === "number") {
                delete state.filters[key];
            }
            state.filters[key] = "";
        }
    },
};

const actions = {
    GET_OFFERS: (context, param) => {
        context.commit("SET_OFFERS_LOADING", true);
        const params = {
            show: param,
        };
        return new Promise((resolve, reject) => {
            AxiosClient.get("/offers/get", { params })
                .then((data) => {
                    context.commit("SET_OFFERS", data.data);
                    context.commit("SET_OFFERS_LOADING_SUCCESS", true);
                    resolve();
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    context.commit("SET_OFFERS_LOADING", false);
                });
        });
    },

    GET_OFFERS_STATISTICS: (context, params) => {
        context.commit("SET_STATISTICS_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.get('/offers/get_statistics', { params })
                .then((data) => {
                    context.commit("SET_STATISTICS", data.data);
                    context.commit("SET_STATISTICS_LOADING_SUCCESS", true);
                    resolve();
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    context.commit("SET_STATISTICS_LOADING", false);
                });
        })
    },
    REFRESH_OFFER_FILTERS: (context) => context.commit("REFRESH_OFFER_FILTERS"),
    GET_UTM_SOURCES_LIST: (context) => {
        context.commit("SET_UTM_SOURCES_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.get("/profile/get_utm_sources")
                .then((data) => {
                    context.commit("SET_UTM_SOURCES", data.data);
                    context.commit("SET_UTM_SOURCES_LOADING_SUCCESS", true);
                    resolve();
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    context.commit("SET_UTM_SOURCES_LOADING", false);
                });
        });
    },

    CHANGE_OFFERS: (context) => {
        context.commit("SET_OFFERS_LOADING", true);
        return new Promise((resolve, reject) => {
            const offers = context.state.offers.data.map((item, index) => {
                item.order = index;
                return item;
            });
            AxiosClient.post("/offers/change_order", offers)
                .then(() => {
                    resolve();
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    context.commit("SET_OFFERS_LOADING", false);
                });
        });
    },

    GET_OFFER_BY_ID: (context, offer_id) => {
        context.commit("SET_OFFERS_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.get(`/offers/get/${offer_id}`)
                .then((response) => {
                    context.commit("SET_CURRENT_OFFER", response.data);
                    resolve(response.data);
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    context.commit("SET_OFFERS_LOADING", false);
                });
        });
    },

    CREATE_OFFER: (context) => {
        context.commit("SET_OFFERS_LOADING", true);
        return new Promise((resolve, reject) => {
            const form = toFormData(context.state.currentOffer);
            AxiosClient.post("/offers/create", form, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
                .then(() => {
                    resolve();
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    context.commit("SET_OFFERS_LOADING", false);
                });
        });
    },

    CREATE_DEFAULT_OFFERS_BY_IDS: (context, params) => {
        context.commit("SET_OFFERS_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.post("/offers/create_from_default", { params })
                .then((data) => {
                    context.commit("SET_APPLICATION_OFFERS", data.data);
                    resolve(data.data);
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    context.commit("SET_OFFERS_LOADING", false);
                });
        });
    },

    UPDATE_OFFER: (context, offerId) => {
        context.commit("SET_OFFERS_LOADING", true);
        return new Promise((resolve, reject) => {
            const form = toFormData(context.state.currentOffer);
            AxiosClient.post(`/offers/update/${offerId}`, form, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
                .then(() => {
                    resolve();
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    context.commit("SET_OFFERS_LOADING", false);
                });
        });
    },

    DELETE_OFFER: (context, offerId) => {
        context.commit("SET_OFFERS_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.post(`/offers/delete/${offerId}`)
                .then(() => {
                    resolve();
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    context.commit("SET_OFFERS_LOADING", false);
                });
        });
    },

    UPDATE_OFFER_SHOW: (context, offer) => {
        context.commit("SET_OFFERS_LOADING", true);
        context.commit("CHANGE_SHOW", offer);
        return new Promise((resolve, reject) => {
            const form = toFormData(offer);
            AxiosClient.post(`/offers/update/${offer.id}`, form, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
                .then(() => {
                    resolve();
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    context.commit("SET_OFFERS_LOADING", false);
                });
        });
    },

    FETCH_SUNFINANCE_TAGS: ({commit}) => {
        commit("SET_OFFERS_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.get(`/offers/tags`)
                .then((response) => {
                    const { tags } = response.data
                    commit("SET_SUNFINANCE_TAGS", tags);
                    resolve(tags);
                })
                .catch(() => reject())
                .finally(() => commit("SET_OFFERS_LOADING", false))
        })
    }
};

export default {
    state,
    getters,
    mutations,
    actions,
};
